import { Container } from './Small.styles';

const FifthTap = ({ isActive = false, children, sx, onClick }) => {
  return (
    <Container isActive={isActive} style={{ ...sx }} onClick={onClick}>
      <div>{children}</div>
    </Container>
  );
};

export default FifthTap;
